var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the type of damaged window.
 * touches: declaration, externalDamage, windowDamage
 * invariants: The selected window type is synchronized with the current window damage data.
 * inputs: available window type choices and user selection.
 * outputs: updates the window damage type through the parent component.
 * see: @declaration/components/externalDamage/DamageDescription/Window/Window.vue
 */
import { Component } from 'vue-property-decorator';
import { UiRadio, UiCard } from '@claims-ia/design-system';
import { WINDOW_TYPE_CHOICES } from '@shared/constants/externalDamages';
import { WINDOW_TYPE_TITLE, WINDOW_TYPE_SUBTITLE } from '@declaration/constants/externalDamages';
import { WindowComponent } from '@declaration/components/externalDamage/DamageDescription/Window/WindowComponent';
let WindowType = class WindowType extends WindowComponent {
    get windowTypeTitle() {
        return this.translateExternalDamageKey(WINDOW_TYPE_TITLE);
    }
    get windowTypeSubtitle() {
        return this.translateExternalDamageKey(WINDOW_TYPE_SUBTITLE);
    }
    get windowTypeChoices() {
        return WINDOW_TYPE_CHOICES;
    }
    get uiChoices() {
        return this.windowTypeChoices.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
};
WindowType = __decorate([
    Component({ components: { UiRadio, UiCard } })
], WindowType);
export default WindowType;
